// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/29b39c8e-1793886355129/" + ({"136":"29b39c8e-1793886355129/HomeError","299":"b7bfefd8"}[chunkId] || chunkId) + ".js";
};